import { Button } from "@omni/ui/components/Button/button.component";
import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { usePaintConfiguratorContext } from "@/components/PaintConfigurator/context/paintConfigurator.context";

const StepIndicator = () => {
    const { currentStep, goToStep, steps } = usePaintConfiguratorContext();
    const { index } = useMapped();

    const step = steps.at(index);

    if (!step || !currentStep) return null;

    return (
        <div className={cn("tw:flex tw:items-center tw:gap-2")}>
            <Button
                color="transparent"
                className={cn("tw:p-1", {
                    "tw:pointer-events-none": index === currentStep.index
                })}
                disabled={index > currentStep.index}
                onClick={() => goToStep(index)}
            >
                <div
                    className={cn("tw:flex tw:flex-col tw:items-center", {
                        "tw:opacity-40": index > currentStep.index
                    })}
                >
                    <div
                        className={cn(
                            "tw:w-2 tw:h-2 tw:rounded-full tw:transition-all tw:duration-500 tw:bg-primary tw:scale-125"
                        )}
                    ></div>
                    <span
                        className={cn(
                            "tw:text-[13.6px] tw:text-primary tw:font-normal tw:mt-1 tw:hidden tw:md:block tw:transition-colors"
                        )}
                    >
                        {step.meta.name}
                    </span>
                </div>
            </Button>
            <div
                className={cn(
                    "tw:w-6 tw:h-px tw:transition-colors tw:duration-500 tw:bg-grey-dark/15",
                    {
                        "tw:hidden": index === steps.length - 1
                    }
                )}
            ></div>
        </div>
    );
};

export { StepIndicator };
